module.exports = __webpack_public_path__ + "static/media/rich16.a9ba9778.JPG";